import React, { useEffect } from "react";
import { Toaster } from 'react-hot-toast';
import { theme } from "src/config";


export const SystemMessage = () => (
  <Toaster
    containerClassName = ""
    containerStyle     = {{}}
    gutter             = {8}
    position           = "top-center"
    reverseOrder       = {true}
    toastOptions       = {{
      duration: 2500,
      success: {
        style: {
          background: 'white',
        },
        iconTheme: {
          primary: theme.color.status.success,
          secondary: 'white',
        },
      },
      error: {
        style: {
          color: 'black',
          background: 'white',
        },
      },
    }}
  />
);